export class HiddenTrackingHTMLElement extends HTMLElement {
    public connectedCallback(): void {
        setTimeout(() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit',
                eventCategory: this.dataset.eventCategory,
                eventAction: this.dataset.eventAction,
                eventLabel: `language_${this.dataset.language}`,
                title: this.textContent.trim() || 'null'
            });
        })
    }
}